import React from 'react';
import { Link } from 'react-router-dom';

const shipped = [
  'Work items on a board, list, timeline, calendar, and workload view',
  'Statuses: New, In Progress, In Review, Blocked, Completed, Cancelled',
  'Dimensions and tags, search, and the ⌘K command palette',
  'Comments, file attachments, and CSV import and export',
  'Pages inside a workspace, plus share links that do not need an account',
  'Roles: Admin, Manager, Contributor, Stakeholder, Guest',
  'Timer, manual time entries, billable flag, and time reports',
  'Budget and utilization on the workspace',
  'Analytics for a workspace: dashboard, team, and time',
  'Portfolio across workspaces, with a Monday 07:00 UTC email',
  'Automation rules, 37 templates, and execution history',
  'Assistant that proposes changes and waits for approval',
  'AI settings for the organization, including consent',
  'API keys and outbound webhooks for Zapier, Make, n8n, and custom code',
  'Organization themes, including Forest and Warm Atelier',
  'Email code on sign-in when the account asks for one',
];

const absent = [
  'Native iOS or Android apps',
  'Video calls or screen sharing inside SynqTag',
  'A built-in Slack, Google Workspace, Microsoft 365, GitHub, or Jira connector',
  'Single sign-on with SAML',
  'A published SOC 2 report',
  'An enterprise contract tier beyond Individual and Team',
];

export const Roadmap: React.FC = () => {
  return (
    <div className="pb-20 pt-28">
      <div className="container-width section-padding">
        <p className="eyebrow">In the product</p>
        <h1 className="max-w-3xl font-display text-4xl sm:text-5xl">Shipped, and not built.</h1>
        <p className="lede mt-5">
          The old roadmap on this site was dated 2025 and listed the assistant and the API as future
          work. Both are in the app. This page is an inventory, not a promise of next quarter.
        </p>

        <div className="mt-12 grid gap-8 lg:grid-cols-2">
          <section className="surface-card p-6">
            <h2 className="font-display text-2xl">In the app now</h2>
            <ul className="mt-4 space-y-3 text-sm leading-relaxed">
              {shipped.map((item) => (
                <li key={item} className="flex gap-2">
                  <span aria-hidden className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-forest" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </section>
          <section className="surface-card p-6">
            <h2 className="font-display text-2xl">Not in the product</h2>
            <p className="mt-2 text-sm text-ink-soft">
              If a page on the wider web still claims these, that page is out of date.
            </p>
            <ul className="mt-4 space-y-3 text-sm leading-relaxed">
              {absent.map((item) => (
                <li key={item} className="flex gap-2">
                  <span aria-hidden className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-tan" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
            <p className="mt-6 text-sm text-ink-soft">
              The way out to other tools is the <Link className="font-semibold text-forest" to="/features">developer API and webhooks</Link>.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};
